import { render, staticRenderFns } from "./AdFormButton.vue?vue&type=template&id=6f85d9a0&scoped=true&"
import script from "./AdFormButton.vue?vue&type=script&lang=js&"
export * from "./AdFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85d9a0",
  null
  
)

export default component.exports